const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_URL_MAP':
			return {...state, ...action.map}
		default: // need this for default case
      		return state ;
    }
}

export default reducer;